const basic = 'detect';

const url = {
  basic: {
    login:`${basic}/login`,
    applyMerchant: `${basic}/merchant-info/apply`,
    queryApplicationsByOpenId: `${basic}/merchant-info/applications/`,
    verifyList:`${basic}/detect-info/list`,
    doVerify:`${basic}/detect-info/do-audit`,
    accountOverview: `${basic}/finance/api/account/overview`,
    listStatements: `${basic}/finance/api/bill-statement/list`,
    createStatements: `${basic}/finance/api/bill-statement/create`,
    listTransactions: `${basic}/finance/api/transaction/list`,
    sendBill: `${basic}/finance/api/bill-statement/send`,
    listRechargeRecords: `${basic}/finance/api/recharge-record/list`,
    createRecharge: `${basic}/finance/api/recharge-record/create`,
    cancelRecharge: `${basic}/finance/api/recharge-record/cancel`,
    confirmRecharge: `${basic}/finance/api/recharge-record/confirm`,
    confirmBill: `${basic}/finance/api/bill-statement/confirm`,
    fetchForAudit: `${basic}/detect-info/fetch-for-audit`,
    openSearch: `${basic}/detect-info/open-search`
  }
};

export default url
